<template>
  <div class="content background1">
    <div class="pageTitle"><p>{{ $t('label_715') }}</p></div>
    <div class="tableBox3">
      <div class="tableMes">
        <div class="table">
          <el-table
            ref="singleTable"
            :data="tableData1"
            highlight-current-row
            @current-change="handleCurrentChange1"
            border
            style="width: 100%;"
            height="820"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                             :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('label_297')" align="center">
              <template slot-scope="scope">
                {{ $t(scope.row.dictKey) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="tableBox4">
      <div class="tableMes">
        <div class="table">
          <!-- <div class="selectBox">
          <div>
            <div class="selectChoose">
              <div class="selectText" style="width: 60px;">
                <p>{{$t('label_157')}}</p>
              </div>
              <div>
                <el-input v-model="selectDataList.val"></el-input>
              </div>
            </div>
          </div>
          <div>
            <div class="selectChoose">
              <div class="selectText" style="width: 60px;">
                <p>{{$t('label_162')}}</p>
              </div>
              <div>
                <el-input v-model="selectDataList.valEn"></el-input>
              </div>
            </div>
          </div>
          <div>
            <div class="selectChoose">
              <div class="selectText" style="width: 60px;">
                <p>{{$t('label_167')}}</p>
              </div>
              <div>
                <el-input v-model="selectDataList.valJa"></el-input>
              </div>
            </div>
          </div>
          <div> -->
          <!-- <div class="btnBox2" >
            <div class="addButton" @click="insert2">{{$t('btn_14')}}</div>
          </div> -->
          <!-- <div class="buttonBox" style="position: absolute; right: 0; bottom: 8px;">
            <div>
              <div class="chooseButton sendButton" @click="selectDict"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
            </div>
          </div>
        </div>
        </div> -->
          <div class="btnBox2">
            <div class="addButton" @click="insert2" v-if="MenuRoleList.indexOf('65')>=0 && btnControl == true"><i
              class="el-icon-circle-plus"></i>{{ $t('btn_14') }}
            </div>
            <div class="editButton" @click="update2" v-if="MenuRoleList.indexOf('66')>=0"><i
              class="el-icon-edit"></i>{{ $t('btn_15') }}
            </div>
            <div class="delButton" @click="del2" v-if="MenuRoleList.indexOf('67')>=0 && btnControl == true"><i
              class="el-icon-delete-solid"></i>{{ $t('btn_16') }}
            </div>
          </div>
          <el-table
            :data="tableData2"
            highlight-current-row
            @current-change="handleCurrentChange2"
            border
            style="width: 100%;"
            height="87%"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                             :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="val"
              :label="$t('label_157')" align="center">
            </el-table-column>
            <el-table-column
              prop="valEn" align="center"
              :label="$t('label_162')">
            </el-table-column>
            <el-table-column
              prop="valJa" align="center"
              :label="$t('label_167')">
            </el-table-column>
            <!-- <el-table-column
              prop="sort" align="center"
              :label="$t('label_501')">
            </el-table-column>
            <el-table-column
              prop="colorShow" align="center"
              :label="$t('label_177')">
              <template slot-scope="scope">
                <el-color-picker  v-model="scope.row.colorShow" disabled></el-color-picker>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div style="position: absolute;bottom: 10px;left: 30%">
          <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                @parentMethod="selectDict1"></Page>
        </div>
      </div>
    </div>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_14')"
      :visible.sync="unInsertVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_157') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.val" clearable></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <!-- <span style="color: #ff0000;margin-top: 10px;">*</span> --><p>{{ $t('label_162') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.valEn" clearable></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <!-- <span style="color: #ff0000;margin-top: 10px;">*</span> --><p>{{ $t('label_167') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.valJa" clearable></el-input>
          </div>
        </div>
        <!-- <div class="dialogMes">
          <p>{{$t('label_172')}}</p>
          <div class="mesInput" style="display: flex;justify-content: center">
            <el-color-picker v-model="dictDataList.colorShow"></el-color-picker>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unInsertSend2"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_15')"
      :visible.sync="unUpdateVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_157') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.val"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_162') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.valEn"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_167') }}</p>
          <div class="mesInput">
            <el-input v-model="dictDataList.valJa"></el-input>
          </div>
        </div>
        <!-- <div class="dialogMes">
          <p>{{$t('label_172')}}</p>
          <div class="mesInput" style="display: flex;justify-content: center">
            <el-color-picker v-model="dictDataList.colorShow"></el-color-picker>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend2"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      :title="$t('btn_16')"
      :visible.sync="unDeleteVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      center
      :before-close="handleClose" custom-class="dialogBox">
      <p style="text-align: center;font-size: 16px">{{ $t('msg_66') }}?</p>
      <div class="btnBox2" style="width: 100%;justify-content: center;">
        <div class="editButton" @click="unDeleteVisible2 = false" style="">{{ $t('btn_1') }}</div>
        <div class="delButton" @click="unDeleteSend2"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import DictPage from "@/assets/js/dictPage/dictPage.js";
import utils from '@/utils/utils'

export default {
  name: 'dictPage',
  components: {
    Page
  },
  data() {
    return {
      saveLoading: false,
      model: [],
      MenuRoleList: [],
      unDetailList: [],
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      options: [{
        value: '0',
        label: this.$t('label_285')
      }, {
        value: '1',
        label: this.$t('label_288')
      }],
      unInsertVisible2: false,
      unUpdateVisible2: false,
      unDeleteVisible2: false,
      stationList: [{
        label: this.$t('label_272'),
        value: '0'
      }],
      workDataList: {
        id: '',
        name: '',
        remarks: '',
      },
      dictDataList: {
        id: '',
        dictId: '',
        val: '',
        valEn: '',
        valJa: '',
      },
      selectDataList: {
        dictId: '',
        val: '',
        valEn: '',
        valJa: ''
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableInfo1: {},
      tableInfo2: {},
      tableInfo3: {},
      ajaxFlag: true,
      btnControl: true
    }
  },
  methods: {
    handler() {

    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    detailPop() {
      this.unDetailVisible = true
    },
    undetailSend() {
      console.log(this.unDetailList);
      this.unDetailVisible = false;
    },
    insert2() {
      this.ajaxFlag = true;
      this.unInsertVisible2 = true;
      this.dictDataList.id = '';
      this.dictDataList.val = '';
      this.dictDataList.valEn = '';
      this.dictDataList.valJa = '';
      this.dictDataList.colorShow = '';
    },
    update2() {
      this.ajaxFlag = true;
      if (Object.keys(this.tableInfo2).length > 0) {
        this.unUpdateVisible2 = true;
        this.dictDataList.id = this.tableInfo2.id;
        this.dictDataList.val = this.tableInfo2.val;
        this.dictDataList.valEn = this.tableInfo2.valEn;
        this.dictDataList.valJa = this.tableInfo2.valJa;
        this.dictDataList.colorShow = this.tableInfo2.colorShow;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    del2() {
      if (Object.keys(this.tableInfo2).length > 0) {
        this.unDeleteVisible2 = true;
        // this.workTimeList.id = this.tableInfo2.id;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    handleClose() {
      this.unDetailList = [];
      this.unInsertVisible2 = false;
      this.unUpdateVisible2 = false;
      this.unDeleteVisible2 = false;
    },
    searchPage() {
      this.selectDictName();
    },
    search() {
      this.searchPage();
    },
    selectDict() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      let dataParam = this.selectDataList;
      let newParam = Object.assign(param, dataParam);
      if (this.selectDataList.dictId != "0") {
        this.selectDictContent(newParam);
      } else {
        this.selectI18n(newParam);
      }
    },
    selectDict1(param) {
      let dataParam = this.selectDataList;
      let newParam = Object.assign(param, dataParam);
      if (this.selectDataList.dictId != "0") {
        this.selectDictContent(newParam);
      } else {
        this.selectI18n(newParam);
      }
    },
    selectDictName() {
      DictPage.selectDictName().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData1 = data.data;
          this.setCurrent(this.tableData1[0]);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectDictContent(param) {
      DictPage.selectDictContent(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData2 = data.data.records;
          this.pageCount = data.data.total;
          this.pageSize = data.data.size;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectI18n(param) {
      DictPage.selectI18n(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData2 = data.data.records;
          this.pageCount = data.data.total;
          this.pageSize = data.data.size;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    refresh() {
      this.selectDataList.dictId = this.tableInfo1.id;
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      let dataParam = this.selectDataList;
      let newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      if (this.selectDataList.dictId != "0") {
        this.selectDictContent(newParam);
      } else {
        this.selectI18n(newParam);
      }
    },
    unInsertSend2() {
      this.saveLoading = true;
      if (utils.isEmpty(this.dictDataList.val)) {
        // utils.tipsAlert(this.$t('msg_43'));
        this.$message.error(this.$t('msg_86'));
        this.saveLoading = false;
        return false;
      }
      // if (utils.isEmpty(this.dictDataList.valEn)) {
      //     utils.tipsAlert("英文内容不能为空");
      //     return false;
      // }
      // if (utils.isEmpty(this.dictDataList.valJa)) {
      //     utils.tipsAlert("日文内容不能为空");
      //     return false;
      // }
      if (this.ajaxFlag) {
        this.ajaxFlag = false;
        if (this.dictDataList.dictId != "0") {
          DictPage.insert1(this.dictDataList).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.unInsertVisible2 = false;
              this.refresh();
              // this.selectDictContent(this.workTimeList.workRestId);
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
            this.ajaxFlag = true;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
            this.ajaxFlag = true;
          })
        } else {
          DictPage.insertI18n(this.dictDataList).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.unInsertVisible2 = false;
              this.refresh();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
            this.ajaxFlag = true;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
            this.ajaxFlag = true;
          })
        }
      }

    },
    unUpdateSend2() {
      this.saveLoading = true;
      if (utils.isEmpty(this.dictDataList.val)) {
        this.$message.error(this.$t('msg_86'));
        this.saveLoading = false;
        // utils.tipsAlert();
        return false;
      }
      // if (utils.isEmpty(this.dictDataList.valEn)) {
      //     utils.tipsAlert("英文内容不能为空");
      //     return false;
      // }
      // if (utils.isEmpty(this.dictDataList.valJa)) {
      //     utils.tipsAlert("日文内容不能为空");
      //     return false;
      // }
      if (this.ajaxFlag) {
        this.ajaxFlag = false;
        if (this.dictDataList.dictId != "0") {
          DictPage.update1(this.dictDataList).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.unUpdateVisible2 = false;
              this.refresh();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
            this.ajaxFlag = true;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
            this.ajaxFlag = true;
          })
        } else {
          DictPage.updateI18n(this.dictDataList).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.unUpdateVisible2 = false;
              this.refresh();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
            this.saveLoading = false;
            this.ajaxFlag = true;
          }).catch((response) => {
            console.log(response)
            this.saveLoading = false;
            this.ajaxFlag = true;
          })
        }
      }

    },
    unDeleteSend2() {
      DictPage.del1(this.tableInfo2.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unDeleteVisible2 = false;
          this.refresh();
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleCurrentChange1(info) {
      this.tableInfo1 = info;
      this.selectDataList.dictId = this.tableInfo1.id;
      this.dictDataList.dictId = this.tableInfo1.id;
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
      let dataParam = this.selectDataList;
      let newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      if (this.tableInfo1.id != "0") {
        this.selectDictContent(newParam);
        this.btnControl = true;
      } else {
        this.selectI18n(newParam);
        this.btnControl = false;
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
      this.workTimeList.workRestId = row.id;
      // this.selectDictContent(this.workTimeList.workRestId);
    },
    handleCurrentChange2(info) {
      this.tableInfo2 = info;
    },
    handleCurrentChange3(info) {
      this.tableInfo3 = info;
    },
  },
  created() {
    this.search();
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/basic/dictPage.vue